<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="jobAnalysisItems"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openJobAnalysisItemDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin th-plugin-values" style="width: 30%">
              <p>
                <span>{{ 'plugins.jobanalysis.jobdata.name' | translate }} *</span>
              </p>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group" formGroupName="JobData">
                <input
                  formControlName="Name"
                  placeholder="{{ 'plugins.jobanalysis.jobdata.jobname' | translate }}"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.jobdata.machine' | translate }} *</span>
              </p>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div
                class="ir-form-group"
                formGroupName="JobData"
                *ngIf="modelsValues && modelsValues.length; else selectionImpossible"
              >
                <input type="hidden" name="Machine" class="ir-form-set" formControlName="Machine" />
                <div class="ir-line ir-select th-select" (click)="openModelsSelector(i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      item.controls['JobData'].controls['Machine'].value
                        ? item.controls['JobData'].controls['Machine'].value
                        : ('plugins.equipment-info.select-machine' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.jobdata.machine' | translate }} #</span>
              </p>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group" formGroupName="JobData">
                <input
                  readonly
                  formControlName="Serial"
                  placeholder="{{ 'plugins.jobanalysis.jobdata.machine' | translate }} #"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.jobdata.material' | translate }}</span>
              </p>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group" formGroupName="JobData">
                <input
                  type="text"
                  formControlName="Material"
                  placeholder="{{ 'plugins.jobanalysis.jobdata.material' | translate }}"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
        </table>
        <table class="ir-plugin-table" [formGroupName]="i">
          <tr class="th-plugin-line--subheader bottom-border">
            <td></td>
            <td class="th-plugin-values">
              <span
                ><strong>{{ 'plugins.jobanalysis.setup.setup-time' | translate }}</strong> ({{
                  'plugins.jobanalysis.setup.min' | translate
                }})</span
              >
            </td>
            <td class="th-plugin-values">
              <span
                ><strong>{{ 'plugins.jobanalysis.output.net-output' | translate }}</strong> ({{
                  'plugins.jobanalysis.output.units-hour' | translate
                }})</span
              >
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td class="th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.performance.current' | translate }}</span>
              </p>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Setup">
                <input formControlName="CurrentPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Output">
                <input formControlName="CurrentPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td class="th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.performance.estimated' | translate }}</span>
              </p>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Setup">
                <input formControlName="EstimatedPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Output">
                <input formControlName="EstimatedPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td class="th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.performance.measured' | translate }}</span>
              </p>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Setup">
                <input formControlName="MeasuredPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin" formGroupName="Output">
                <input formControlName="MeasuredPerformance" type="number" min="0" max="99999" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td class="th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.performance.acceptance-rate' | translate }}</span>
              </p>
            </td>
            <td colspan="2" class="th-plugin-values">
              <div class="ir-form-group margin" style="text-align: center">
                <input
                  style="width: 50%; display: inline-block"
                  formControlName="AcceptanceRate"
                  type="number"
                  min="0"
                  max="99999"
                  class="ir-form-set"
                />
                <span> %</span>
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td class="th-plugin-values">
              <p>
                <span>{{ 'plugins.jobanalysis.performance.comment' | translate }}</span>
              </p>
            </td>
            <td colspan="2" class="th-plugin-values">
              <div class="ir-form-group margin">
                <textarea
                  autosize
                  formControlName="Comment"
                  [minRows]="1"
                  [maxRows]="20"
                  placeholder="Your Comment"
                  class="ir-form-set"
                ></textarea>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectModelsMenu($event)" (modalClosed)="onClose()" #modelsModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #jobDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>job</strong>?'"
  [danger]="true"
></confirm>
<ng-template #selectionImpossible>
  <p class="th-required" style="display: inline-block">
    <span>{{ 'plugins.jobanalysis.machine.select-impossible' | translate }}</span>
  </p>
</ng-template>
